/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_RbacInputs */

const en_admin_nav_rbac = /** @type {(inputs: Admin_Nav_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const zh_admin_nav_rbac = /** @type {(inputs: Admin_Nav_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限管理`)
};

/**
* | output |
* | --- |
* | "RBAC" |
*
* @param {Admin_Nav_RbacInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_rbac = /** @type {((inputs?: Admin_Nav_RbacInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_RbacInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_rbac(inputs)
	return zh_admin_nav_rbac(inputs)
});
export { admin_nav_rbac as "admin.nav.rbac" }